import React__default from 'react';
import { Icon } from '@grandvisionhq/icons';

const getBankIcon = (bank)=>{
    switch(bank){
        case 'ASN Bank':
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "asn",
                name: "asn",
                viewBox: "7 0 26 26",
                width: 26,
                height: 26
            });
        case 'bunq':
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "bunq",
                name: "bunq",
                viewBox: "0 0 40 24",
                width: 40,
                height: 24
            });
        case 'Knab':
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "knab",
                name: "knab",
                viewBox: "0 0 39 28",
                width: 39,
                height: 30
            });
        case 'Rabobank':
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "rabo",
                name: "rabo",
                viewBox: "7 0 25 30",
                width: 25,
                height: 30
            });
        case 'RegioBank':
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "regio",
                name: "regio",
                viewBox: "0 7 47 20",
                width: 47,
                height: 30
            });
        case 'Revolut':
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "revolut",
                name: "revolut",
                viewBox: "7 0 28 28",
                width: 28,
                height: 28
            });
        case 'Triodos Bank':
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "triodos",
                name: "triodos",
                viewBox: "7 2 25 25",
                width: 25,
                height: 25
            });
        case 'Van Lanschot Bankiers':
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "vanLanschot",
                name: "vanLanschot",
                viewBox: "9 0 22 26",
                width: 22,
                height: 26
            });
        case 'ABN':
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "abn",
                name: "abn",
                viewBox: "10 2 22 24",
                width: 22,
                height: 24
            });
        case 'ABN Amro':
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "abnAmro",
                name: "abnAmro",
                viewBox: "0 0 30 28",
                width: 30,
                height: 28
            });
        case 'ING':
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "ing",
                name: "ing",
                viewBox: "0 0 28 22",
                width: 28,
                height: 22
            });
        case 'Yoursafe':
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "yourSafe",
                name: "yourSafe",
                viewBox: "0 0 28 25",
                width: 28,
                height: 25
            });
        case 'SNS':
        case 'SNS Bank':
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "sns",
                name: "sns",
                viewBox: "0 0 25 25",
                width: 25,
                height: 25
            });
        default:
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "bank",
                name: "bank",
                viewBox: "0 0 30 24",
                width: 30,
                height: 24
            });
    }
};

export { getBankIcon };
//# sourceMappingURL=get-bank-icons.js.map
